// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .invoice-dialog {
  height: 100vh;
  width: 100%;
  max-width: none !important;
}
::ng-deep .invoice-dialog .mat-dialog-container {
  display: flex;
  padding: 0 !important;
}

:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

header {
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.0509803922) 0 1px 2px, rgba(0, 0, 0, 0.0509803922) 0 1px 4px, rgba(0, 0, 0, 0.0509803922) 0 2px 8px;
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 15px 0 10px;
  z-index: 9;
}
header img {
  height: 24px;
  margin-left: 10px;
}
header button + img {
  margin-left: 5px;
}
header .title {
  margin-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
header .download {
  margin-left: auto;
}

iframe, embed {
  background-color: #f7f8fa;
  border: none;
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/dms/etax-shared/invoice-viewer/invoice-viewer.component.scss"],"names":[],"mappings":"AAAA;EACG,aAAA;EACA,WAAA;EACA,0BAAA;AACH;AACG;EACG,aAAA;EACA,qBAAA;AACN;;AAGA;EACG,aAAA;EACA,sBAAA;EACA,OAAA;EACA,gBAAA;AAAH;;AAGA;EACG,gBAAA;EACA,+HAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;AAAH;AAEG;EACG,YAAA;EACA,iBAAA;AAAN;AAGG;EACG,gBAAA;AADN;AAIG;EACG,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFN;AAKG;EACG,iBAAA;AAHN;;AAOA;EACG,yBAAA;EACA,YAAA;EACA,OAAA;AAJH","sourcesContent":["::ng-deep .invoice-dialog {\n   height: 100vh;\n   width: 100%;\n   max-width: none !important;\n\n   .mat-dialog-container {\n      display: flex;\n      padding: 0 !important;\n   }\n}\n\n:host {\n   display: flex;\n   flex-direction: column;\n   flex: 1;\n   overflow: hidden;\n}\n\nheader {\n   background: #fff;\n   box-shadow: #0000000d 0 1px 2px, #0000000d 0 1px 4px, #0000000d 0 2px 8px;\n   display: flex;\n   align-items: center;\n   height: 50px;\n   padding: 0 15px 0 10px;\n   z-index: 9;\n\n   img {\n      height: 24px;\n      margin-left: 10px;\n   }\n\n   button + img {\n      margin-left: 5px;\n   }\n\n   .title {\n      margin-left: 10px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n   }\n\n   .download {\n      margin-left: auto;\n   }\n}\n\niframe, embed {\n   background-color: #f7f8fa;\n   border: none;\n   flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
